module.exports = __webpack_public_path__ + "img/4.c950cb7a.png";